import { Text, View } from '@react-pdf/renderer';
import { styles } from './PDFStyles';
import { format } from 'date-fns';

interface PDFHeaderProps {
  provider: {
    name: string;
  };
  version: {
    version_number: string;
    effective_date: string | null;
  };
  region?: {
    name: string;
    zip_code?: string;
  } | null;
}

export function PDFHeader({ provider, version, region }: PDFHeaderProps) {
  // Safely format the effective date
  const formatEffectiveDate = (dateString: string | null) => {
    if (!dateString) return '';
    try {
      return ` | Effective Date: ${format(new Date(dateString), "PP")}`;
    } catch (error) {
      console.warn('Error formatting effective date:', error);
      return '';
    }
  };

  // Safely format the region info
  const formatRegionInfo = (regionData?: { name: string; zip_code?: string } | null) => {
    if (!regionData || !regionData.name) return '';
    const zipCode = regionData.zip_code ? ` (${regionData.zip_code})` : '';
    return ` | Region: ${regionData.name}${zipCode}`;
  };

  return (
    <View style={styles.header}>
      <Text style={styles.title}>
        {provider.name || 'Unknown Provider'}
      </Text>
      <Text style={styles.subtitle}>
        Version {version.version_number || 'Unknown'}
        {formatEffectiveDate(version.effective_date)}
        {formatRegionInfo(region)}
      </Text>
    </View>
  );
}
